import { lazy } from "react";

export const StoreLocator = lazy(() =>
  import(
    /* webpackChunkName: "StoreLocator" */
    "./StoreLocator.component"
  )
);

export const StoreLocatorPrismic = lazy(() =>
  import(
    /* webpackChunkName: "StoreLocatorPrismic" */
    "./StoreLocatorPrismic/StoreLocatorPrismic.component"
  )
);
